// module
import React from 'react';
import PropTypes from 'prop-types';

class ContentLink extends React.Component {
    render(){
        const {link} = this.props;
        return(
            <div className="content_link">
                <a href={link}>
                    {link}
                </a>
            </div>
        );
    }
}

ContentLink.propTypes={
    link: PropTypes.string.isRequired
}

export default ContentLink;